// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;Mighty king, who loves justice,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;you have established equity;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;you have executed justice and righteousness in Jacob.<br> </p> </div></div>";
// Exports
module.exports = code;